module.exports = __webpack_public_path__ + "img/vacaciones-nimrod-thumbnail.389d8881.jpg";